export default __webpack_public_path__ + "static/media/swine.e3f2e96d.jpg";